import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFaceGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M25.1 40c-4.06 0-7.52-.15-9.49-2.33-1.34-1.48-1.83-3.76-1.51-6.96a.75.75 0 0 1 .82-.67c.41.04.71.41.67.82-.28 2.76.09 4.66 1.13 5.8 1.68 1.85 5.2 1.84 9.32 1.83h1c1.37 0 2.41-.36 3.08-1.08 1.29-1.38 1.13-3.87 1.04-5.2-.03-.47-.05-.78-.02-1.01.12-.86 1.05-1.11 1.8-1.31.25-.07.67-.18.86-.29-.05-.11-.19-.32-.54-.67-2.74-2.73-2.76-4.54-2.79-6.64-.02-1.5-.04-3.2-1.05-5.77-2.41-6.11-10.17-7.02-14.58-7.02-.41 0-.75-.34-.75-.75s.34-.75.75-.75c4.79 0 13.23 1.04 15.98 7.98 1.12 2.83 1.14 4.75 1.16 6.3.02 1.98.04 3.29 2.35 5.59.52.52 1.19 1.3.96 2.14-.23.86-1.19 1.12-1.96 1.33-.21.06-.53.14-.7.22 0 .15.02.37.03.56.1 1.56.29 4.47-1.44 6.33-.97 1.02-2.38 1.55-4.18 1.55H25.1Z",
    fill: "currentColor"
  }));
}

export { SvgFaceGlyphSecondary as default };
